// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 9ca3sE4gAMHXGHWcmrUodR
// Component: I4KEAjFVJ9
import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Navbar from "../../Navbar"; // plasmic-import: 5Pxe45fpZL/component
import CanvasView from "../../CanvasView"; // plasmic-import: 7Fu6fQ1ynQ/component

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_main.module.css"; // plasmic-import: 9ca3sE4gAMHXGHWcmrUodR/projectcss
import sty from "./PlasmicProjectpage.module.css"; // plasmic-import: I4KEAjFVJ9/css

export type PlasmicProjectpage__VariantMembers = {};

export type PlasmicProjectpage__VariantsArgs = {};
type VariantPropType = keyof PlasmicProjectpage__VariantsArgs;
export const PlasmicProjectpage__VariantProps = new Array<VariantPropType>();

export type PlasmicProjectpage__ArgsType = {};
type ArgPropType = keyof PlasmicProjectpage__ArgsType;
export const PlasmicProjectpage__ArgProps = new Array<ArgPropType>();

export type PlasmicProjectpage__OverridesType = {
  root?: p.Flex<"div">;
  navbar?: p.Flex<typeof Navbar>;
  canvasView?: p.Flex<typeof CanvasView>;
};

export interface DefaultProjectpageProps {
  className?: string;
}

function PlasmicProjectpage__RenderFunc(props: {
  variants: PlasmicProjectpage__VariantsArgs;
  args: PlasmicProjectpage__ArgsType;
  overrides: PlasmicProjectpage__OverridesType;

  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(
    () =>
      Object.assign(
        {},

        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <React.Fragment>
      {}

      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          projectcss.plasmic_tokens,
          sty.root
        )}
      >
        <Navbar
          data-plasmic-name={"navbar"}
          data-plasmic-override={overrides.navbar}
          className={classNames("__wab_instance", sty.navbar)}
        />

        <CanvasView
          data-plasmic-name={"canvasView"}
          data-plasmic-override={overrides.canvasView}
          className={classNames("__wab_instance", sty.canvasView)}
        />
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "navbar", "canvasView"],
  navbar: ["navbar"],
  canvasView: ["canvasView"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  navbar: typeof Navbar;
  canvasView: typeof CanvasView;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicProjectpage__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicProjectpage__VariantsArgs;
    args?: PlasmicProjectpage__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicProjectpage__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicProjectpage__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicProjectpage__ArgProps,
          internalVariantPropNames: PlasmicProjectpage__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicProjectpage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicProjectpage";
  } else {
    func.displayName = `PlasmicProjectpage.${nodeName}`;
  }
  return func;
}

export const PlasmicProjectpage = Object.assign(
  // Top-level PlasmicProjectpage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    navbar: makeNodeComponent("navbar"),
    canvasView: makeNodeComponent("canvasView"),

    // Metadata about props expected for PlasmicProjectpage
    internalVariantProps: PlasmicProjectpage__VariantProps,
    internalArgProps: PlasmicProjectpage__ArgProps,

    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicProjectpage;
/* prettier-ignore-end */
